export default "__VITE_ASSET__49610e2f__"